
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface NavBarLogoProps {
  navigate?: any;
}

export const NavBarLogo: React.FC<NavBarLogoProps> = ({ navigate: navigateProp }) => {
  const navigateHook = useNavigate();
  
  const handleClick = () => {
    // Use the provided navigation prop if available, otherwise use the hook
    if (navigateProp) {
      navigateProp('/');
    } else {
      navigateHook('/');
    }
  };

  return (
    <div 
      className="cursor-pointer" 
      onClick={handleClick}
    >
      <img 
        src="/lovable-uploads/ca9986fa-ca51-473a-952a-b52aa082d052.png" 
        alt="Logo" 
        className="h-10" 
      />
    </div>
  );
};
